// libs
import React from 'react';

// components
import { Redirect, Prompt } from "react-router-dom";
import { Link } from 'react-router-dom';
import Header from "../../components/Header";
import TextInput from "../../components/Form/components/TextInput";
import DateTextInput from '../../components/Form/components/TextInput/DateTextInput';
import LoadingSpinner from "../../components/LoadingSpinner";
import SelectInput from "../../components/Form/components/SelectInput";
import CheckboxInput from "../../components/Form/components/CheckboxInput";
import MobileTextInput from '../../components/Form/components/TextInput/MobileTextInput';
import PostcodeTextInput from '../../components/Form/components/TextInput/PostcodeTextInput';
import EmailTextInput from '../../components/Form/components/TextInput/EmailTextInput';
import SuburbAutoComplete from '../../components/Form/components/AutoCompleteInput/SuburbAutoComplete';
import HelpTip from "../../components/HelpTip";
import ReceiptTextInput from "../../components/Form/components/TextInput/ReceiptTextInput";

// services
import withAuth from "../../services/withAuth";
import MembersApi from "../../services/portal-api/MembersApi";
import GlobalsApi from "../../services/portal-api/GlobalsApi";
import AuthService from "../../services/AuthService";
import { COUNTRY_STATE_OPTIONS, COUNTRY_OPTIONS, STORE_LOCATION_OPTIONS_AU, STORE_LOCATION_OPTIONS_NZ, COUNTRY_STATE_OPTIONS_NZ, COUNTRY_STATE_OPTIONS_AU } from "../../helpers/Constants";
import moment from "moment";
import SalespersonIdTextInput from '../../components/Form/components/TextInput/SalespersonIdTextInput';
import NotFound from '../NotFound';

class NewMember extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            isEdited: false,
            isLoadingDigitalCardStockLevel: true,
            digitalCardStockLevel: 0,
            isLoadingIsEmailAvailable: false,
            isEmailAvailable: true,
            data: {
                isDigitalCard: true,
                rewardsCardNumber: '',
                hiddenRewardsCardNumber: '',
                receiptNumber: '',
                firstName: '',
                lastName: '',
                email: '',
                noEmail: false,
                hiddenEmail: '',
                mobile: '',
                birthday: '',
                noBirthday: false,
                hiddenBirthday: '',
                postcode: '',
                countryState: '',
                optInNewsletter: AuthService.can('receive promotional emails - opt in by default') ? true : false,
                storeLocationId: '',
                country: '',
                // Set a default expiry date
                rewardsExpiryDate: '',
            },
            stores: [],
            errors: {},
            viewSlug: null,
            stringSuburbs: ''
        };
        this.clsd = false;
        this.searchSuburbs = this.searchSuburbs.bind(this);
        this.handleSuburbSelected = this.handleSuburbSelected.bind(this);
        this.getStockLevelCallId = null;
        this.stringSuburbs = '';
    }

    componentDidMount() {
        document.title = 'New Member - duskPortal';
        document.body.className = 'page--green';
        $('input:first').focus();
        // $('.select').customSelect();null

        const storeId = AuthService.getFuturaStoreId();
        const data = this.state.data;
        // if (storeId && !AuthService.isAdmin()) {
        //     const posId = window.localStorage.getItem('posId') || '';
        //     data['receiptNumber'] = `${storeId}/${posId}`;
        //     this.setState({
        //         data: data,
        //     });
        // }

        this._loadStockLevel();
        this._selectCountry();
        this._loadStores();

        //console.log(localStorage.getItem("globals_nz").suburbs);
    }


    _loadStores() {
        MembersApi.getStores((result) => {
            //const data  = this.state;
            //console.log(typeof result.json,result);
            //data["stores"] = result.json;
            if (result.success) {
                let stores = result.json.map((i, j) => ({
                    key: i.id,
                    value: i.name + ", " + i.state,
                }));
                this.setState({
                    'stores': stores,
                }, () => { console.log(this.state) });
            }
        });
    }

    _selectCountry() {
        MembersApi.getCountry((result, callId) => {
            const data = this.state.data;
            let country = result.json.country;
            if (country == "NZ") {
                data["country"] = "globals_nz";
            } else if (country == "AU") {
                data["country"] = "globals_au";
            }

            if (result.success) {
                this.setState({
                    data: data,
                }, () => {
                    console.log("country", this.state.data.country);
                });
            } else {

                if (result.status === 401) {
                    this.props.sessionExpired();
                    this.setState({
                        isLoading: false,
                    });
                    return;
                }
            }
        });

    }

    handleSuburbSelected(suburb) {
        const { data } = this.state;
        data['suburb'] = suburb.suburb;
        data['postcode'] = suburb.postcode;
        data['countryState'] = suburb.state.toLowerCase();

        this.setState({
            data: data,
        });
    }

    _loadStockLevel = () => {
        this.setState({
            isLoadingDigitalCardStockLevel: true,
        });
        this.getStockLevelCallId = MembersApi.getStockLevel((result, callId) => {

            // Check if we're still interested in this response
            if (callId !== this.getStockLevelCallId) {
                return;
            }

            // Minimal error handling required
            if (!result.success) {
                this.setState({
                    'isLoadingDigitalCardStockLevel': false,
                });
                return;
            }

            // Update UI based on value
            const data = this.state.data;
            //data.isDigitalCard = (
            //    this.state.data.isDigitalCard &&
            //    result.json.stockLevel > 0
            //);
            const errors = this.state.errors;
            if (result.json.stockLevel <= 0) {
                errors.isDigitalCard = 'Sorry, digital card numbers are currently out of stock.';
            }
            this.setState({
                'isLoadingDigitalCardStockLevel': false,
                'digitalCardStockLevel': result.json.stockLevel,
                'data': data,
                'errors': errors,
            });
        });
    };

    handleInput = (event) => {
        const errors = this.state.errors;
        const name = event.target.name;
        delete errors[name];
        let data = this.state.data;

        //if(name != 'birthday')
        data[name] = event.target.type === 'checkbox' ? event.target.checked : event.target.value;
        if (event.target.value == "globals_nz" || event.target.value == "globals_au") {
            data['suburb'] = null;
            data['postcode'] = "";
            data['countryState'] = "";
            data['storeLocationId'] = "";
        }

        if (name === 'mobile' && data['country']) {
            const actualNumberFormat = event.target.value;
            const countryCode = data['country'];
            const mobileNumber = event.target.value.trim();
    
            // AU validation
            if (countryCode === "globals_au") {
                if (!mobileNumber.startsWith("04") || mobileNumber.length !== 10) {
                    errors.mobile = "Mobile number needs to start with 04 and must be 10 digits long";
                }
            }
    
            // NZ validation
            if (countryCode === "globals_nz") {
                if (!mobileNumber.startsWith("02") || mobileNumber.length < 9 || mobileNumber.length > 11) {
                    errors.mobile = "Mobile number needs to start with 02 and must be between 9 to 11 digits long";
                }
            }

            if(mobileNumber.length == 0) {
                delete errors.mobile;
            }

            if(mobileNumber.length >= 9) {
                MembersApi.isMobileNumberAvailable(actualNumberFormat, (result) => {
                    if(result.success) {
                        if(result.json.result == false){
                            errors.mobile = "This mobile number is already in use";
                            this.setState({
                                errors: errors
                            }, () => {
                                this.forceUpdate();
                            });
                        }
                    }
                });
            }
        }

        //console.log(data);
        this.setState({
            data: data,
            errors: errors,
            isEdited: true,
        });
    };

    onEmailBlur = (event, email) => {

        email = email.trim();

        // Check if required
        const isRequired = (
            !this.state.data.noEmail &&
            email !== '' &&
            email !== this.lastCheckedEmail
        );
        if (!isRequired) {
            return;
        }


        // Perform query
        this.lastCheckedEmail = email;
        this.setState({
            isLoadingIsEmailAvailable: true,
            isEmailAvailable: true,
        });

        this.getIsEmailAvailableCallId = MembersApi.getIsEmailAvailable(email, (result, callId) => {

            // Check if we're still interested in this response
            if (callId !== this.getIsEmailAvailableCallId) {
                return;
            }

            // Minimal error handling required
            if (!result.success) {
                this.setState({
                    isLoadingIsEmailAvailable: false,
                    isEmailAvailable: true,
                });
                return;
            }

            // Update UI based on value
            this.setState({
                isLoadingIsEmailAvailable: false,
                isEmailAvailable: result.json.result,
            });
        });
    };

    onBirthdayBlur = (event) => {
        const errors = this.state.errors;
        const name = event.target.name;
        delete errors[name];
        let data = this.state.data;
        let val = new Date(event.target.value).toLocaleDateString('en-GB');
        let j = moment().format('YYYY-MM-DD HH:mm:ss');
        let k = moment(val.toString(), 'DD/MM/YYYY', true).format('YYYY-MM-DD HH:mm:ss');

        if (moment(val, 'DD/MM/YYYY', true).isValid() == false) {
            errors[name] = "Date must be in DD/MM/YYYY format. Please try again";
        } else if (moment(j).diff(moment(k), 'years') > window.maxAge) {
            errors[name] = "Birthday must not be older than " + window.maxAge + " years";
        }

        if (moment(val, 'DD/MM/YYYY', true).isAfter()) {
            errors[name] = "Birthday must not be in the future";
        }

        this.setState({
            data: data,
            errors: errors,
            isEdited: true,
        });

    }

    dateDiffInDays(a, b, d) {
        // Discard the time and time-zone information.
        const utc1 = Date.UTC(a.getFullYear(), a.getMonth(), a.getDate());
        const utc2 = Date.UTC(b.getFullYear(), b.getMonth(), b.getDate());

        return Math.floor((utc2 - utc1) / d);
    }

    _toggleIsDigitalCard = (event) => {
        const isDigitalCard = event.target.checked;
        const data = this.state.data;
        const errors = this.state.errors;
        if (isDigitalCard) {
            // Store value
            data['hiddenRewardsCardNumber'] = data['rewardsCardNumber'];
            // Clear value
            delete errors['rewardsCardNumber'];
            data['rewardsCardNumber'] = '';
            this.setState({ data: data, errors: errors });
        }
        else {
            // Restore hidden value
            data['rewardsCardNumber'] = data['hiddenRewardsCardNumber'];
        }
        this.setState({ data: data, errors: errors });
        this.handleInput(event);
    };

    /* _populateSuburbToGlobals = (event) => {
         let suburbs = GlobalsApi.getSuburbs((result)=> {
             console.log(result);
         });
         this.handleInput(event);
     }*/

    _toggleNoEmail = (event) => {
        const noEmail = event.target.checked;
        const data = this.state.data;
        const errors = this.state.errors;
        if (noEmail) {
            // Store value
            data['hiddenEmail'] = data['email'];
            // Clear value
            delete errors['email'];
            data['email'] = '';

            // Clear optInNewsletter
            delete errors['optInNewsletter'];
            data['optInNewsletter'] = false;
            this.setState({ data: data, errors: errors });
        }
        else {
            // Restore hidden value
            data['email'] = data['hiddenEmail'];
        }
        this.setState({ data: data, errors: errors });
        this.handleInput(event);
    };

    _toggleOptInNewsletter = (event) => {
        const optIn = event.target.checked;
        if (optIn) {
            const data = this.state.data;
            const errors = this.state.errors;

            // Clear noEmail
            delete errors['noEmail'];
            data['noEmail'] = false;
            this.setState({ data: data, errors: errors });
        }
        this.handleInput(event);
    };

    _toggleNoBirthday = (event) => {
        const noBirthday = event.target.checked;
        const data = this.state.data;
        const errors = this.state.errors;
        if (noBirthday) {
            // Store value
            data['hiddenBirthday'] = data['birthday'];
            // Clear value
            delete errors['birthday'];
            data['birthday'] = '';
        }
        else {
            // Restore hidden value
            data['birthday'] = data['hiddenBirthday'];
        }
        this.setState({ data: data, errors: errors });
        this.handleInput(event);
    };

    searchSuburbs(_value) {
        const value = _value.toLowerCase().trim();
        const {
            suburbs,
        } = this.state;

        if (suburbs) {
            const matches = suburbs.filter(sub => sub.key.indexOf(value) !== -1)
            const distanceMatches = matches.map(m => ({ ...m, dist: m.key.length - value.length }));
            distanceMatches.sort((a, b) => a.dist - b.dist);
            return distanceMatches;
        }
        return [];
    }

    handleSubmit = (event) => {
        // Prevent default behaviour
        event.preventDefault();

        const errors = this.state.errors;

        // check for errors in mobile number
        if (errors.hasOwnProperty('mobile')) {
            return false;
        }
        // Show loading and reset state
        this.setState({
            isLoading: true,
            errors: {},
        });

        // update local storage to keep receipt number posId
        const { receiptNumber } = this.state.data;
        if (receiptNumber && AuthService.isAdmin()) {
            const posId = receiptNumber.split('/')[1];
            window.localStorage.setItem('posId', posId);
        }

        this.clsd = false;
        // Fetch data

        const updatedData = {
            ...this.state.data,
            birthday: moment(this.state.data.birthday).format('DD/MM/YYYY'),
            rewardsExpiryDate: this.state.data.rewardsExpiryDate == '' ? moment().add(2, 'years').format('DD/MM/YYYY') : moment(this.state.data.rewardsExpiryDate).format('DD/MM/YYYY'),
        };

        this.newMemberCallId = MembersApi.newMember(updatedData, (response, callId) => {

            // Check if we're still interesting in this response
            if (callId !== this.newMemberCallId) {
                return;
            }

            // Check for errors
            if (response.success) {
                // Redirect away
                this.setState({
                    isLoading: false,
                    isEdited: false,
                    viewSlug: response.json.slug,
                });
            }
            else {
                // Check for auth
                if (response.status === 401) {
                    this.props.sessionExpired();
                    this.setState({
                        isLoading: false,
                    });
                    return;
                }

                if (response.json.errors) {
                    this.setState({
                        isLoading: false,
                        errors: response.json.errors,
                    });
                }
                else if (response.json.error) {
                    this.setState({
                        isLoading: false,
                        errors: { error: response.json.error },
                    });
                }
                else {
                    this.setState({
                        isLoading: false,
                    });
                }
            }
        });
    };

    render() {
        console.log(this.state.data.isDigitalCard);

        if (sessionStorage.getItem("globals_nz") == null || sessionStorage.getItem("globals_nz") == 'undefined' || sessionStorage.getItem("globals_nz") == "") {
            GlobalsApi.getSuburbs('NZ', (result, callId) => {
                sessionStorage.setItem("globals_nz", JSON.stringify(result.json));
                // this.stringSuburbs = JSON.stringify(result.json);
                this.setState({
                    stringSuburbs: JSON.stringify(result.json)
                }, () => {
                    console.log("New Zealand: ", this.state.stringSuburbs);
                })
                // this.forceUpdate();
            });
        }

        if (sessionStorage.getItem("globals_au") == null || sessionStorage.getItem("globals_au") == 'undefined' || sessionStorage.getItem("globals_au") == "") {
            GlobalsApi.getSuburbs('AU', (result, callId) => {
                sessionStorage.setItem("globals_au", JSON.stringify(result.json));
                // this.stringSuburbs = JSON.stringify(result.json);
                // this.forceUpdate();
                this.setState({
                    stringSuburbs: JSON.stringify(result.json)
                }, () => {
                    console.log("Australia: ", this.state.stringSuburbs);
                })
            });
        }

        if (this.state.viewSlug) {
            return (<Redirect to={'/members/' + this.state.viewSlug} />);
        }

        let emailWarning = null;
        if (this.state.data.noEmail) {
            emailWarning = 'Member cannot receive promotion vouchers.';
        }
        else if (!this.state.isEmailAvailable) {
            const url = '/members?q=' + encodeURI(this.state.data.email);
            emailWarning = (<span>Email address already belongs to a member. <Link to={url}>Click to view</Link>.</span>);
        }

        let birthdayWarning = null;
        if (this.state.data.noBirthday) {
            birthdayWarning = 'Member cannot receive Birthday promotion.';
        }
        let newsletterWarning = null;
        // if (!this.state.data.optInNewsletter) {
        //     newsletterWarning = 'Member must opt-in to receive promotion vouchers.';
        // } 
        // Member will get vouchers even if they do not opt-in to newsletter.
        let countryOptions = null;
        if (!this.state.data.country) {
            countryOptions = [];
        } else {
            if (this.state.data.country == "globals_nz")
                countryOptions = COUNTRY_STATE_OPTIONS_NZ;
            if (this.state.data.country == "globals_au")
                countryOptions = COUNTRY_STATE_OPTIONS_AU;
        }


        let ActiveCountry = ''
        if (this.state.data.country == "globals_nz")
            ActiveCountry = "New Zealand";
        if (this.state.data.country == "globals_au")
            ActiveCountry = "Australia";

        const isDigitalCardEnabled = this.state.digitalCardStockLevel > 0;
        let isDigitalCardLabel = '';
        if (!this.state.isLoadingDigitalCardStockLevel && AuthService.isAdmin()) {
            isDigitalCardLabel += 'Create a digital rewards card. The number will be shown on the next screen. (Stock level: ' + this.state.digitalCardStockLevel + ')';
        }
        const errorsmsg = [];
        for (const [key, value] of Object.entries(this.state.errors)) {
            if (this.clsd)
                continue;
            errorsmsg.push(<div key={key} className="alert alert--outline alert--error margin--40--top">{!AuthService.isAdmin() && <span>Sorry, unable to create member: {value} Please try again, or contact Loyalty Support if the problem persists.</span>} {AuthService.isAdmin() && <span>Sorry, unable to create member: {value}</span>}</div>);
        }
        return (
            AuthService.can('Create member') ?
                <div>
                    <Prompt when={this.state.isEdited} message="You have unsaved changes that will be lost. Are you sure you want to leave this page?" />
                    <Header />
                    <main className="content" role="main">
                        <div className="container padding--60">

                            <h2 className="text--40 text--light text--color">Create New Member</h2>

                            {errorsmsg}

                            <form onSubmit={this.handleSubmit} className="margin--40--top validate loading--inline padding--100--bot" autoComplete="off">
                                <span></span>
                                {AuthService.can('Stock information field') && 
                                    <div className="col"><span style={{ color: "grey", fontSize: 16 }}>{isDigitalCardLabel}</span><br /></div>
                                }
                                <br />
                                <div className="col-2 gutter--40">
                                    <SalespersonIdTextInput
                                        label={`Team Member ID${AuthService.can('is team member id manadatory') ? '' : ' (Optional)'}`}
                                        initialId={this.state.data.salespersonId}
                                        value={this.state.data.salespersonId || ''}
                                        error={this.state.errors.salespersonId}
                                        onChange={this.handleInput}
                                        required={AuthService.can('is team member id manadatory')}
                                        name="salespersonId"
                                        id="salespersonId"
                                        onChangeCountry={this.handleInput}
                                        country={this.state.data.country}
                                    />
                                    <div className="col">
                                        <label className="sub-title text--grey">Country</label>
                                        <div className="col-2"><strong>{ActiveCountry}</strong></div>
                                    </div>
                                    <div className="col">
                                        <TextInput
                                            name="firstName"
                                            label="First Name"
                                            value={this.state.data.firstName}
                                            error={this.state.errors.firstName}
                                            onChange={this.handleInput}
                                            required={true}
                                        />
                                    </div>
                                    <div className="col">
                                        <TextInput
                                            name="lastName"
                                            label="Last Name"
                                            value={this.state.data.lastName}
                                            error={this.state.errors.lastName}
                                            onChange={this.handleInput}
                                            required={true}
                                        />
                                    </div>
                                    <div className="col">
                                        <EmailTextInput
                                            name="email"
                                            label="Email Address"
                                            value={this.state.data.email}
                                            error={this.state.errors.email}
                                            warning={emailWarning}
                                            onChange={this.handleInput}
                                            onBlur={this.onEmailBlur}
                                            type="email"
                                            required={!this.state.data.noEmail}
                                            disabled={this.state.data.noEmail}
                                        />
                                        <CheckboxInput
                                            name="noEmail"
                                            label="No Email Address"
                                            isChecked={this.state.data.noEmail}
                                            onChange={this._toggleNoEmail}
                                        />
                                    </div>
                                    <div className="col">
                                        <CheckboxInput
                                            name="optInNewsletter"
                                            title="Receive Promotional Emails"
                                            label="Yes, member would like to receive promotional emails from dusk."
                                            isChecked={this.state.data.optInNewsletter}
                                            error={this.state.errors.optInNewsletter}
                                            warning={newsletterWarning}
                                            onChange={this._toggleOptInNewsletter}
                                        />
                                    </div>
                                    <div className="col">
                                        <div className="col-2 gutter--40">
                                            <div className="col">
                                                <div className="col">
                                                    <MobileTextInput
                                                        name="mobile"
                                                        label="Mobile Number (Optional)"
                                                        value={this.state.data.mobile}
                                                        error={this.state.errors.mobile}
                                                        onChange={this.handleInput}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col">
                                                <DateTextInput
                                                    name="birthday"
                                                    label="Birthdate"
                                                    placeholder={(!this.state.data.noBirthday) ? 'DD/MM/YYYY' : ''}
                                                    value={this.state.data.birthday}
                                                    error={this.state.errors.birthday}
                                                    warning={birthdayWarning}
                                                    onBlur={this.onBirthdayBlur}
                                                    onChange={this.handleInput}
                                                    required={!this.state.data.noBirthday}
                                                    disabled={this.state.data.noBirthday}
                                                />
                                                <CheckboxInput
                                                    name="noBirthday"
                                                    label="No Birthdate"
                                                    isChecked={this.state.data.noBirthday}
                                                    onChange={this._toggleNoBirthday}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col">
                                        <div className="col-3 gutter--15 suburb-state-postcode">
                                            <div className="col">
                                                <SuburbAutoComplete
                                                    name="suburb"
                                                    label="Suburb (Optional)"
                                                    value={this.state.data.suburb}
                                                    error={this.state.errors.suburb}
                                                    onChange={this.handleInput}
                                                    onSuburbSelected={this.handleSuburbSelected}
                                                    country={this.state.data.country}
                                                    extras={this.state.stringSuburbs}
                                                />
                                            </div>
                                            <div className="col">
                                                <SelectInput
                                                    name="countryState"
                                                    label="State"
                                                    options={countryOptions}
                                                    value={this.state.data.countryState}
                                                    error={this.state.errors.countryState}
                                                    onChange={this.handleInput}
                                                    required={true}
                                                />
                                            </div>
                                            <div className="col">
                                                <PostcodeTextInput
                                                    name="postcode"
                                                    label="Postcode"
                                                    value={this.state.data.postcode}
                                                    error={this.state.errors.postcode}
                                                    onChange={this.handleInput}
                                                    required={true}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    {/* {(AuthService.isAdmin() || AuthService.getAdminType() == 3) && */}
                                    {AuthService.can('Store location field') &&
                                        <div className="col">
                                            <SelectInput
                                                name="storeLocationId"
                                                label="Store Location (Admin only)"
                                                options={this.state.stores}
                                                value={this.state.data.storeLocationId}
                                                error={this.state.errors.storeLocationId}
                                                onChange={this.handleInput}
                                                required={true}
                                            />
                                        </div>
                                    }
                                    {AuthService.can('Expiry date field') &&
                                        <div className="col">
                                            <div className="col-2 gutter--40">
                                                <div className="col">
                                                    <DateTextInput
                                                        name="rewardsExpiryDate"
                                                        label="Expiry Date (Admin only)"
                                                        placeholder={(!this.state.data.rewardsExpiryDate) ? 'DD/MM/YYYY' : ''}
                                                        value={this.state.data.rewardsExpiryDate}
                                                        error={this.state.errors.rewardsExpiryDate}
                                                        onChange={this.handleInput}
                                                    // required={true}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    }

                                </div>
                                <footer className="footer--form clearfix">
                                    <div className="footer--form__left">
                                    </div>
                                    <div className="footer--form__right">
                                        <button type="submit" className="btn btn--large btn--color">Create</button>
                                    </div>
                                </footer>
                                <LoadingSpinner isVisible={this.state.isLoading} />
                            </form>

                        </div>
                    </main>
                </div>
                : <NotFound forbidden={true} />
        );
    }
}

export default withAuth(NewMember);
